import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {billingLicencesActionTypes, LoadBillingLicencesSuccessAction} from '../actions/licences';

export interface BillingLicencesState {
  // tslint:disable-next-line:no-any
  array: any[];
}

const initialState: BillingLicencesState = {
  array: []
};

export function BillingLicencesReducer(state: BillingLicencesState = initialState, action: Action): BillingLicencesState {
  switch (action.type) {
    case billingLicencesActionTypes.LOAD_SUCCESS:
      return handleLoadSuccessAction(state, action);
    case billingLicencesActionTypes.LOAD_FAIL:
      return handleLoadFailAction(state);
    default:
      return state;
  }
}

function handleLoadSuccessAction(state: BillingLicencesState, action: LoadBillingLicencesSuccessAction): BillingLicencesState {
  const newState = _.clone(state);
  newState.array = action.payload;
  return newState;
}



function handleLoadFailAction(state: BillingLicencesState): BillingLicencesState {
  const newState = _.clone(state);
  newState.array = [];
  return newState;
}


export const billingLicencesSelectors = {
  array: (state: BillingLicencesState) => _.get(state, 'array', [])
};
